import { render, staticRenderFns } from "./CategoryInformationalContent.vue?vue&type=template&id=70f6d19e&name=description&"
import script from "./CategoryInformationalContent.vue?vue&type=script&lang=js&"
export * from "./CategoryInformationalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports